import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { AppDownloadButtons } from "@/components/AppDownloadButtons";
import { APPS_PUBLISHED } from "@/lib/appStore";

// Modal prompting the user to download the mobile app after sign-up.
export function AppDownloadModal({ open, onOpenChange, onContinue, role }) {
  if (!APPS_PUBLISHED) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="app-download-modal" className="sm:max-w-md">
        <DialogHeader>
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-2 overflow-hidden">
            <img src={`${process.env.PUBLIC_URL}/app-icon.png`} alt="Screening Services Mobile app icon" className="w-full h-full object-contain" />
          </div>
          <DialogTitle className="font-heading text-2xl text-[#1E3F33]">Take us with you</DialogTitle>
          <DialogDescription className="text-[#5C6B64]">
            {role === "collector"
              ? "Get instant alerts for new customer leads and respond on the go — download the Screening Services Mobile app."
              : "Track your requests, get collector updates, and manage everything from your phone — download the Screening Services Mobile app."}
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <AppDownloadButtons />
        </div>
        <DialogFooter>
          <button
            type="button"
            data-testid="app-download-continue"
            onClick={onContinue}
            className="btn-primary w-full"
          >
            Continue to the website
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
